<template>
  <div :class="containerClasses">
    <div class="former-boolean-options">
      <button
        v-for="option in options"
        :key="option.value"
        :class="classes(option.value)"
        :disabled="disabled || field.disabled"
        @click="change(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
  import BOOLEAN_OPTIONS from '@/helpers/options/boolean';

  export default {
    name: 'FormerBoolean',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      field: {
        type: Object,
        default() {
          return {};
        },
      },
      value: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
    },
    computed: {
      options() {
        const {
          options,
        } = this.field;

        if (options && options.length) {
          return options;
        }

        return BOOLEAN_OPTIONS;
      },
      containerClasses() {
        const classes = ['former-boolean'];

        if (this.color) {
          classes.push(`former-boolean-color-${this.color}`);
        }

        if (this.disabled) {
          classes.push('former-boolean-disabled');
        }

        if (this.field.errors && this.field.errors.length) {
          classes.push('former-boolean-error');
        }

        return classes;
      },
    },
    methods: {
      classes(bool) {
        const cls = ['former-boolean-option'];

        cls.push(`former-boolean-option-${bool}`);

        if (String(this.value) === String(bool)) {
          cls.push('former-boolean-option-selected');
        } else if ([null, undefined, ''].indexOf(this.value) === -1) {
          cls.push('former-boolean-option-unselected');
        }

        return cls;
      },
      focus() {

      },
      change(bool) {
        this.$emit('input', String(bool));
        this.$emit('change', String(bool));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-boolean {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .former-boolean-options {
    @include former-field;
    @include former-field-desktop;

    align-items: stretch;
    background-color: var(--cordel-color-constant-light);
    background-color: var(--cordel-color-neutral-lighter);
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;

    .former-boolean-error & {
      background-color: var(--cordel-color-alert-danger);
      color: var(--cordel-color-constant-light);
    }
  }

  .former-boolean-option {
    @include button-reset;

    border-radius: inherit;
    cursor: pointer;
    flex: 1;
    transition: color 0.1s, background-color 0.1s;
  }

  .former-boolean-disabled {
    .former-boolean-option {
      cursor: not-allowed;
    }

    .former-boolean-option-selected {
      background-color: var(--cordel-color-neutral-primary);
      color: var(--cordel-color-constant-light);
    }
  }

  .former-boolean-option-selected {
    background-color: var(--cordel-color-brand-primary);
    color: var(--cordel-color-constant-light);
  }

  .former-boolean-option-unselected {
    .former-boolean-disabled & {
      color: var(--cordel-color-neutral-primary);
    }
  }
</style>
